// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MediaApiModel$PorterinFeature from "../../../media/domain/api-models/MediaApiModel.mjs";
import * as SharedApiModel$PorterinFeature from "../../../core/domain/api-models/SharedApiModel.mjs";
import * as VehicleApiModel$PorterinFeature from "./VehicleApiModel.mjs";

function link_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var link = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
  if (link.TAG === /* Ok */0) {
    var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                link: link._0,
                label: label._0
              }
            };
    }
    var e = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = link._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".link" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function link_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var links = Decco.arrayFromJson(link_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "links"), null));
    if (links.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                links: links._0
              }
            };
    }
    var e = links._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".links" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_internal_links_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var link_section = Decco.arrayFromJson(link_section_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "link_section"), null));
    if (link_section.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                link_section: link_section._0
              }
            };
    }
    var e = link_section._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".link_section" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_internal_links_attr_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = section_internal_links_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_internal_links_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.optionFromJson(section_internal_links_attr_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_faqs_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var faqs_section = SharedApiModel$PorterinFeature.faqs_section_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "faqs_section"), null));
  if (faqs_section.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              faqs_section: faqs_section._0
            }
          };
  }
  var e = faqs_section._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".faqs_section" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_faqs_attr_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = section_faqs_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_faqs_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.optionFromJson(section_faqs_attr_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_banner_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var banner_img = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "banner_img"), null));
  if (banner_img.TAG === /* Ok */0) {
    var banner_img_mobile = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "banner_img_mobile"), null));
    if (banner_img_mobile.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                banner_img: banner_img._0,
                banner_img_mobile: banner_img_mobile._0
              }
            };
    }
    var e = banner_img_mobile._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".banner_img_mobile" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = banner_img._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".banner_img" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_banner_attr_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = section_banner_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_banner_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = section_banner_attr_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_download_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var download_app_mobile = SharedApiModel$PorterinFeature.download_app_mobile_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "download_app_mobile"), null));
  if (download_app_mobile.TAG === /* Ok */0) {
    var download_app_desktop = SharedApiModel$PorterinFeature.download_app_desktop_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "download_app_desktop"), null));
    if (download_app_desktop.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                download_app_mobile: download_app_mobile._0,
                download_app_desktop: download_app_desktop._0
              }
            };
    }
    var e = download_app_desktop._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".download_app_desktop" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = download_app_mobile._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".download_app_mobile" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_download_attr_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = section_download_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_download_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = section_download_attr_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_seo_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                sub_text: sub_text._0
              }
            };
    }
    var e = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_seo_attr_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = section_seo_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_seo_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.optionFromJson(section_seo_attr_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_other_services_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var other_services = VehicleApiModel$PorterinFeature.other_services_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "other_services"), null));
  if (other_services.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              other_services: other_services._0
            }
          };
  }
  var e = other_services._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".other_services" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_other_services_attr_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = section_other_services_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_other_services_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.optionFromJson(section_other_services_attr_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function vehicle_fare_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var fare = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare"), null));
  if (fare.TAG === /* Ok */0) {
    var vehicle = VehicleApiModel$PorterinFeature.vehicle_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle"), null));
    if (vehicle.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                fare: fare._0,
                vehicle: vehicle._0
              }
            };
    }
    var e = vehicle._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = fare._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fare" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function vehicle_fare_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var vehicle = Decco.arrayFromJson(vehicle_fare_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "vehicle"), null));
  if (vehicle.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              vehicle: vehicle._0
            }
          };
  }
  var e = vehicle._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vehicle" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_fare_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var light_vehicles_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "light_vehicles_title"), null));
    if (light_vehicles_title.TAG === /* Ok */0) {
      var heavy_vehicles_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "heavy_vehicles_title"), null));
      if (heavy_vehicles_title.TAG === /* Ok */0) {
        var know_more_cta = SharedApiModel$PorterinFeature.know_more_cta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "know_more_cta"), null));
        if (know_more_cta.TAG === /* Ok */0) {
          var light_vehicle_data = Decco.optionFromJson(vehicle_fare_data_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "light_vehicle_data"), null));
          if (light_vehicle_data.TAG === /* Ok */0) {
            var heavy_vehicle_data = Decco.optionFromJson(vehicle_fare_data_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "heavy_vehicle_data"), null));
            if (heavy_vehicle_data.TAG === /* Ok */0) {
              var capacity_icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "capacity_icon"), null));
              if (capacity_icon.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          title: title._0,
                          light_vehicles_title: light_vehicles_title._0,
                          heavy_vehicles_title: heavy_vehicles_title._0,
                          know_more_cta: know_more_cta._0,
                          light_vehicle_data: light_vehicle_data._0,
                          heavy_vehicle_data: heavy_vehicle_data._0,
                          capacity_icon: capacity_icon._0
                        }
                      };
              }
              var e = capacity_icon._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".capacity_icon" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = heavy_vehicle_data._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".heavy_vehicle_data" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = light_vehicle_data._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".light_vehicle_data" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = know_more_cta._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".know_more_cta" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = heavy_vehicles_title._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".heavy_vehicles_title" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = light_vehicles_title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".light_vehicles_title" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function section_fare_attributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = section_fare_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_fare_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.optionFromJson(section_fare_attributes_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function area_list_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var area_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "area_name"), null));
  if (area_name.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              area_name: area_name._0
            }
          };
  }
  var e = area_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".area_name" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function areas_served_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var area_list = Decco.arrayFromJson(area_list_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "area_list"), null));
    if (area_list.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                area_list: area_list._0
              }
            };
    }
    var e = area_list._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".area_list" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_area_served_attr_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = areas_served_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_area_served_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.optionFromJson(section_area_served_attr_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function outstation_text_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                sub_text: sub_text._0
              }
            };
    }
    var e = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_outstation_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var outstation = Decco.arrayFromJson(outstation_text_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "outstation"), null));
    if (outstation.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                outstation: outstation._0
              }
            };
    }
    var e = outstation._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".outstation" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_outstation_attr_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = section_outstation_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_outstation_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.optionFromJson(section_outstation_attr_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function hero_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var know_more_cta = SharedApiModel$PorterinFeature.know_more_cta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "know_more_cta"), null));
      if (know_more_cta.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  title: title._0,
                  sub_text: sub_text._0,
                  know_more_cta: know_more_cta._0
                }
              };
      }
      var e = know_more_cta._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".know_more_cta" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function pointers_text_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var feature_list = Decco.arrayFromJson(SharedApiModel$PorterinFeature.title_subtext_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "feature_list"), null));
    if (feature_list.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                feature_list: feature_list._0
              }
            };
    }
    var e = feature_list._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".feature_list" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_pointers_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var features = pointers_text_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "features"), null));
  if (features.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              features: features._0
            }
          };
  }
  var e = features._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".features" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_pointers_attr_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = section_pointers_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function section_pointers_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.optionFromJson(section_pointers_attr_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  link_decode ,
  link_section_decode ,
  section_internal_links_decode ,
  section_internal_links_attr_decode ,
  section_internal_links_data_decode ,
  section_faqs_decode ,
  section_faqs_attr_decode ,
  section_faqs_data_decode ,
  section_banner_decode ,
  section_banner_attr_decode ,
  section_banner_data_decode ,
  section_download_decode ,
  section_download_attr_decode ,
  section_download_data_decode ,
  section_seo_decode ,
  section_seo_attr_decode ,
  section_seo_data_decode ,
  section_other_services_decode ,
  section_other_services_attr_decode ,
  section_other_services_data_decode ,
  vehicle_fare_decode ,
  vehicle_fare_data_decode ,
  section_fare_decode ,
  section_fare_attributes_decode ,
  section_fare_data_decode ,
  area_list_decode ,
  areas_served_decode ,
  section_area_served_attr_decode ,
  section_area_served_data_decode ,
  outstation_text_decode ,
  section_outstation_decode ,
  section_outstation_attr_decode ,
  section_outstation_data_decode ,
  hero_section_decode ,
  pointers_text_decode ,
  section_pointers_decode ,
  section_pointers_attr_decode ,
  section_pointers_data_decode ,
}
/* No side effect */
